'use client';
import { useEffect } from 'react';

export default function CookieSettings() {
  const containerId = 'cookieDeclarationContainer';

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://consent.cookiebot.com/977d4895-6345-4253-8a1c-6cc7ec2e8061/cd.js';
    script.id = 'CookieDeclaration';
    script.type = 'text/javascript';
    script.async = true;
    document.getElementById(containerId)?.appendChild(script);
  }, []);

  return <div id={containerId}></div>;
}
